/* eslint-disable no-undef */

const checkoutAddons = () => {
  // Hide terms and conditions and proceed buttons for Klarna Checkout payment.
  const kco = document.getElementById('payment_method_kco');
  if (kco) {
    const payment = document.querySelector("[data-tab='payment']");
    if (payment) {
      payment.classList.add('kco');
    }
  }
};

export default checkoutAddons;
